import { ReturnStoreAddress } from "../helper"
import ParseFloat from "../ParseFloat"
export const ReturnPickupAndDeliveryAddress = (orderDetail: any) => {
    const _orderDetailstoreData = orderDetail?.store_data
    return orderDetail?.order_category == 3
        ? orderDetail?.delivery_address ? ReturnStoreAddress({ address: orderDetail?.delivery_address, postal_code: orderDetail?.zip_code }) : "Address not available"
        : `${_orderDetailstoreData
            ? _orderDetailstoreData?.[0]?.store_name : ""
        }, ${_orderDetailstoreData?.[0]?.address},${_orderDetailstoreData?.[0]?.postal_code}`;
}


export const ReturnDeliveryAndPickup = (orderDetail: any) => {
    return orderDetail?.order_category == 3 ? "Deliver to:" : "Pickup from:"
}

export const ReturnPriceAndFree = (price: any) => {
    const pRice = price ? ParseFloat(price) : 'Free'
    return `(${pRice})`
}




export const ReturnPrice = (p: any) => {
    const price = p?.web_price ? p?.web_price : p?.price;
    return price || 0
}

export const orderMealItemVariationSize = (item: any) => {
    const variation_name = item?.selected_variations?.[0]?.name;
    if (variation_name) {
        return `(${variation_name})`
    }
    return ''
}


const sumOfOrderOptions = (selected_step_options: any) => {
    const sumOfOptions = selected_step_options?.reduce((acc: any, cu: any) => {
        acc += ReturnPrice(cu)
        return acc;
    }, 0);
    return sumOfOptions || 0
}

const sumOfOrderSubCategory = (selected_sub_categories: any) => {
    const sumOfCategory = selected_sub_categories?.reduce((acc: any, cu: any) => {
        acc += ReturnPrice(cu)
        return acc;
    }, 0);
    return sumOfCategory || 0
}

const sumOfOrderAddOns = (selected_add_ons: any) => {
    const sumOfAddons = selected_add_ons?.reduce((acc: any, cu: any) => {
        acc += ReturnPrice(cu)
        return acc;
    }, 0);
    return sumOfAddons || 0
}



// @@ Meal all item sum
export const TotalPriceOfMealItem = (item: any) => {
    let total_item_price = 0;
    let addonsItem = []
    for (let mealItem of item) {
        addonsItem.push(mealItem?.item_name)
        const sumOfOptions = sumOfOrderOptions(mealItem?.selected_step_options);
        const sumOfCategory = sumOfOrderSubCategory(mealItem?.selected_sub_categories)
        const sumOfAddOn = sumOfOrderAddOns(mealItem?.selected_add_ons);
        // console.log("sumOfOptions", sumOfOptions, sumOfCategory, sumOfAddOn)
        total_item_price += ((ReturnPrice(mealItem)) + (sumOfOptions || 0) + (sumOfCategory || 0) + (sumOfAddOn || 0))

    }
    return { addonsItem: addonsItem.join(","), addonsPrice: total_item_price || 0 }
}

